<template>
    <el-form
        class="u-page-wrapper"
        label-position="top"
        hide-required-asterisk
        @submit.native.prevent="handleLogin"
    >
        <el-form-item>
            <el-input
                v-model="email"
                placeholder="Email"
                type="email"
                autocomplete="username"
                required
            />
        </el-form-item>

        <el-form-item>
            <el-input
                v-model="password"
                placeholder="Password"
                type="password"
                required
            />
        </el-form-item>

        <el-button native-type="submit" type="primary">Anmelden</el-button>
    </el-form>
</template>

<script>
export default {
    data () {
        return {
            email: '',
            password: '',
        }
    },

    computed: {
        isLoggedIn () {
            return this.$store.getters.isLoggedIn
        },
    },

    watch: {
        isLoggedIn () {
            if (this.isLoggedIn) {
                this.$router.push({ name: 'Home' })
            }
        },
    },

    methods: {
        async handleLogin () {
            try {
                await this.$appwrite.account.createEmailSession(
                    this.email,
                    this.password,
                )

                const { $id, name } = await this.$appwrite.account.get()
                this.$store.commit('setUser', { id: $id, name })
            } catch (error) {
                this.$notify({
                    title: 'Error',
                    message: error.message,
                    type: 'error',
                })
            }
        },
    },
}
</script>

<style lang="scss" scoped>
</style>
